"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var Listing = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsxs)("span", {
                style: {
                    fontWeight: "bold"
                },
                children: [
                    label,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)("span", {
                children: [
                    " ",
                    value
                ]
            })
        ]
    });
};
var _default = Listing;
